import { Navigate, Route, Routes } from 'react-router-dom';
import { usePlatformAuth } from './contexts/PlatformAuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminLayout } from './layouts/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { PlansPage } from './pages/PlansPage';
import { AddonsPage } from './pages/AddonsPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { OrganizationDetailPage } from './pages/OrganizationDetailPage';
import { RendersPage } from './pages/RendersPage';
import { SettingsPage } from './pages/SettingsPage';
import { Box, CircularProgress } from '@mui/material';

function LoginRoute() {
  const { isAuthenticated, loading } = usePlatformAuth();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <LoginPage />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route path="addons" element={<AddonsPage />} />
          <Route path="organizations" element={<OrganizationsPage />} />
          <Route path="organizations/:uuid" element={<OrganizationDetailPage />} />
          <Route path="renders" element={<RendersPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
